import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Message from "@mui/icons-material/Message";
import AccessTime from "@mui/icons-material/AccessTime";
import CalendarToday from "@mui/icons-material/CalendarToday";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import Place from "@mui/icons-material/Place";
import React from "react";
import Delete from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ConfirmDialog from "./ConfirmDialog";

export default function JobRequestCommentCard(props) {
  const comment = props.comment;

  const [confirmDialog, setConfirmDialog] = React.useState({
    isOpen: false,
    title: "",
    id: "",
    subtitle: "",
  });

  function handleDelete() {
    setConfirmDialog({
      isOpen: true,
      id: comment.id,
      title: "Ta bort meddelande",
      subtitle:
        "Det här kommer ta bort meddelandet. Du har ingen möjlighet att återskapa det.",
    });
  }
  // Hantera case där man har tagit bort annonsen
  if (!comment.jobRequest) {
    return (
      <>
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
          refreshFunc={props.getInterestsByUser}
          whatToDelete="message"
          message="Din annons har tagits bort!"
        />
        <Card style={{ backgroundColor: "d3d3d3", marginTop: "30px" }}>
          <CardHeader
            style={{ padding: "1vh" }}
            action={
              <IconButton aria-label="settings" onClick={handleDelete}>
                <Delete />
              </IconButton>
            }
            title="Annonsen är borttagen"
          />
          <List>
            <ListItem>
              <List>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <Message />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={comment.message}></ListItemText>
                </ListItem>
              </List>
            </ListItem>
          </List>
        </Card>
      </>
    );
  } else {
    const cert = comment.jobRequest["id06"] && "Kräver ID06";
    const company = comment.jobRequest.company;
    const date =
      comment.jobRequest.startNow === "startNow"
        ? " Omgående"
        : comment.jobRequest.startDate;
    //const date = comment.jobRequest.startDate;
    const jobLength =
      comment.jobRequest === 1
        ? "1 dag"
        : comment.jobRequest.jobLength + " dagar";
    const county = comment.jobRequest.county;
    const municipality = comment.jobRequest.municipality;
    const description = comment.jobRequest.description;
    const status = comment.jobRequest.status;

    // Changing background on items that aren't active
    const bgColor = status === "active" ? "#fff" : "#d3d3d3";
    return (
      <>
        <Card style={{ background: bgColor, marginTop: "30px" }}>
          <CardHeader
            style={{ padding: "1vh" }}
            action={
              <IconButton aria-label="settings" onClick={handleDelete}>
                <Delete />
              </IconButton>
            }
            title={company}
          />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
            refreshFunc={props.getInterestsByUser}
            whatToDelete="message"
            message="Din annons har tagits bort!"
          />
          <CardContent style={{ padding: "1vh" }}>
            <Grid container spacing={1}>
              <Grid item xs={9} sm={3}>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(0,0,0,0.54)",
                  }}
                >
                  <Place />
                  {municipality}
                  {", "}
                  {county}
                </span>
              </Grid>
              <Grid item xs={3} sm={3}>
                {cert && (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "rgba(0,0,0,0.54)",
                    }}
                  >
                    <ErrorOutline /> {cert}
                  </span>
                )}
              </Grid>
              <Grid item xs={6} sm={3}>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(0,0,0,0.54)",
                  }}
                >
                  <CalendarToday />
                  {date}
                </span>
              </Grid>
              <Grid item xs={6} sm={3}>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "rgba(0,0,0,0.54)",
                    justifyContent: "flex-start",
                  }}
                >
                  <AccessTime />
                  {jobLength}
                </span>
              </Grid>
            </Grid>
          </CardContent>
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <div>{description}</div>
              </Grid>
            </Grid>
          </CardContent>
          <List>
            <ListItem>
              <List>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <Message />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={comment.message}></ListItemText>
                </ListItem>
              </List>
            </ListItem>
          </List>
        </Card>
      </>
    );
  }
}
